export default "__VITE_ASSET__P1$1hWc1__$_?format=webp__"